import { BaseTextFieldProps, OutlinedInputProps } from "@mui/material";
import { useField } from "formik";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import { I18nTranslator } from "utils/i18n";

export interface IEFormTextField extends BaseTextFieldProps {
  id: string;
  label: string;
  placeholder?: string;
  onChange?: any;
  InputProps?: Partial<OutlinedInputProps>;
  defaultValue?: string | number;
  renderValue?(value: string): string;
}

const FormTextField = (props: IEFormTextField) => {
  const { id, label, onChange, InputProps, defaultValue, renderValue } = props;
  const [field, meta] = useField(id);

  return (
    <TextField
      {...props}
      id={id}
      name={id}
      label={label}
      fullWidth
      variant="outlined"
      InputProps={InputProps}
      error={meta.touched && !_.isEmpty(meta.error)}
      helperText={meta.touched && meta.error && I18nTranslator(meta.error)}
      onChange={onChange || field.onChange}
      value={
        (renderValue && renderValue(meta.value)) ||
        meta.value?.toString() ||
        defaultValue ||
        ""
      }
    />
  );
};

export default FormTextField;
